/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../../theme/theme"
import { css } from "@emotion/react"
import { Box, List, ListItem, ListItemText } from "@mui/material"
import { mobileCss } from "../../../util/isMobile"
import { FormStep } from "../../common/constants/formSteps"

const SidebarContainerStyle = withMyTheme((theme) => css`
    width: 250px;
    height: 100%;
    background-color: ${theme.palette.grey[50]};
    border-right: 1px solid ${theme.palette.divider};
    overflow-y: auto;
    flex-shrink: 0;
    
    ${mobileCss(`
        width: 100%;
        height: auto;
        border-right: none;
        border-bottom: 1px solid ${theme.palette.divider};
        overflow-y: visible;
    `)}
`)

const StepListStyle = withMyTheme((theme) => css`
    padding: 1rem 0;
    
    ${mobileCss(`
        padding: 0.5rem 0;
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
    `)}
`)

const StepItemStyle = withMyTheme((theme) => css`
    cursor: pointer;
    transition: background-color 0.2s;
    border-left: 4px solid transparent;
    
    &:hover {
        background-color: ${theme.palette.grey[100]};
    }
    
    &.selected {
        background-color: ${theme.palette.primary.light}20;
        border-left-color: ${theme.palette.primary.main};
        
        .MuiListItemText-primary {
            color: ${theme.palette.primary.main};
            font-weight: 600;
        }
    }
    
    ${mobileCss(`
        flex-shrink: 0;
        border-left: none;
        border-bottom: 3px solid transparent;
        
        &.selected {
            border-left: none;
            border-bottom-color: ${theme.palette.primary.main};
        }
    `)}
`)

interface EditorSidebarProps {
    steps: FormStep[];
    selectedStepId: string;
    onStepSelect: (stepId: string) => void;
}

export const EditorSidebar = ({ steps, selectedStepId, onStepSelect }: EditorSidebarProps) => {
    return (
        <Box css={SidebarContainerStyle}>
            <List css={StepListStyle}>
                {steps.map((step) => (
                    <ListItem
                        key={step.id}
                        onClick={() => onStepSelect(step.id)}
                        className={selectedStepId === step.id ? 'selected' : ''}
                        css={StepItemStyle}
                    >
                        <ListItemText 
                            primary={step.title}
                            primaryTypographyProps={{
                                fontSize: '0.95rem'
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}
